var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"content":_vm.$t('remove')}},[_c('BaseButton',{staticClass:"remove btn-link",attrs:{"type":"danger","size":_vm.size,"icon":""},on:{"click":_vm.click}},[_c('i',{staticClass:"far fa-trash-alt"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }